import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDetailLinkState } from '../utils/navigationState';

export function useNavigateToDetail() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback((to, tab, extraState = {}, options = {}) => {
    navigate(to, {
      state: { ...getDetailLinkState(location, tab), ...extraState },
      ...options,
    });
  }, [navigate, location]);
}
